import { Icon } from '@chakra-ui/react';

export const EyeOpenIcon = (props: any) => (
  <Icon aria-label="eye open icon" viewBox="4 4 16 16" {...props}>
    <path
      d="m11.6666667 9.5c2.3011864 0 4.3845198 1.25 6.25 3.75-1.8654802 2.5-3.9488136 3.75-6.25 3.75-2.30118649 0-4.38451982-1.25-6.25000003-3.75 1.86548021-2.5 3.94881354-3.75 6.25000003-3.75zm0 1.25c-1.6418692 0-3.18127579.8048769-4.64866711 2.5 1.46739132 1.6951231 3.00679791 2.5 4.64866711 2.5 1.6418691 0 3.1812757-.8048769 4.648667-2.5-1.4673913-1.6951231-3.0067979-2.5-4.648667-2.5zm0 .625c1.0355339 0 1.875.8394661 1.875 1.875s-.8394661 1.875-1.875 1.875-1.87500003-.8394661-1.87500003-1.875.83946613-1.875 1.87500003-1.875zm-4.54246828-3.75 1.25 2.16506351-1.08253175.62499999-1.25-2.1650635zm8.91746828 0 1.0825317.625-1.25 2.1650635-1.0825317-.62499999zm-3.75-.625v1.875h-1.25v-1.875z"
      fill="currentColor"
    />
  </Icon>
);
